import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { leadMobileFromUrl } from "./leadMobileFromUrl";

/**
 * /m/:leadMobile — same lead capture as ?m=, then land on catalog with query preserved.
 */
export default function LeadMobileRedirect() {
  const { leadMobile } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const mobile =
      (leadMobile != null && String(leadMobile).trim()) ||
      leadMobileFromUrl(window.location.href);
    if (mobile) {
      localStorage.setItem("storeLeadMobile", mobile);
    }
    const search = location.search || "";
    navigate({ pathname: "/products", search }, { replace: true });
  }, [leadMobile, location.search, navigate]);

  return null;
}
